import React from 'react';
import PropTypes from 'prop-types';

import CardTitle from '../../../Elements/CardTitle/CardTitle';
import QuoteCard from '../QuoteCard/QuoteCard';
import Button from '../../../Input/Button/Button';

import './CustomerQuotesSection.scss';

const customerQuotes = [
    {
        header: {
            src: 'v1556814219/employer/banner/kgfilpj04nmwd043zb0v.jpg',
            alt: 'Salesforce banner',
        },
        logo: {
            src: 'v1545073594/companyLogo/salesforce_2x.png',
            alt: 'Salesforce logo',
        },
        quote:
            '“At Salesforce, we encourage candidates and employers to share their feedback. Platforms like Fairygodboss are essential to advancing the conversation around gender equality and pay equity.”',
        author:
            '— Cindy Robbins, President and Chief People Officer, Salesforce',
    },
    {
        header: {
            src: 'v1562891370/employer/banner/t8eeqqfb32nmizjnegae.png',
            alt: 'Qualtrics banner',
        },
        logo: {
            src: 'v1579189722/companyLogo/Qualtrics2.png',
            alt: 'Qualtrics logo',
        },
        quote:
            '“Fairygodboss has over-delivered on our expectations every step of the way. We see a strong ROI from our partnership in terms of employer brand and qualified applications to our posted jobs.”',
        author: '— Shaunda Zilich, Global Talent Brand Manager, Qualtrics',
    },
];

export default class CustomerQuotesSection extends React.PureComponent {
    renderQuoteCard = (quoteCardProps, index) => {
        return <QuoteCard {...quoteCardProps} key={`quote-${index}`} />;
    };

    render() {
        return (
            <div className="component-Employer-Marketing-CustomerQuotesSection">
                <CardTitle className="quotes-heading">
                    {this.props.title}
                </CardTitle>
                <div className="quotes">
                    {customerQuotes.map(this.renderQuoteCard)}
                </div>
                <Button
                    className="learn-more"
                    inputStyle="purple-medium-white"
                    value={this.props.buttonText}
                    onClick={this.props.onDemoButtonClick}
                />
            </div>
        );
    }
}

CustomerQuotesSection.propTypes = {
    title: PropTypes.string,
    buttonText: PropTypes.string,
    onDemoButtonClick: PropTypes.func.isRequired,
};

CustomerQuotesSection.defaultProps = {
    title: 'What Our Customers are Saying About Fairygodboss',
    buttonText: 'Learn more',
};
